module.exports = __webpack_public_path__ + "static/media/ic_appointment.5271362f.svg";